let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("a0ybh"), load("fTFcV"), load("hzVe9")]).then(() => parcelRequire('dSB3l'));